// SPDX-License-Identifier: AGPL-3.0-or-later

import {GenericErrorModal} from '@app/features/app/components/alerts/GenericErrorModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const InviteRevokeFailedModal = observer(() => {
	const {t} = useLingui();
	return (
		<GenericErrorModal
			title={t`Failed to Revoke Invite`}
			message={t`We couldn't revoke the invite at this time. The invite link may still be active. Please try again in a moment.`}
		/>
	);
});
